import React, { useState } from 'react'
import Modal from 'react-modal'
import { Button, Glyphicon } from 'react-bootstrap'

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  deleteData: Function,
  deleteSubadmin: Function,
  updateSubadmin: Function,
  subadmin: { _id: String, name: String, email: String, phone: String, terminals: [String] },
  availableTerminals: Array<{
    _id: String,
    name: String,
    email: String,
    area: String,
    password: String,
    carrier: String,
  }>,
}

const HandleSubadminModal = ({ isModalOpen, closeModal, subadmin, availableTerminals, updateSubadmin, deleteSubadmin }: Props) => {
  const [name, setName] = useState(subadmin.name)
  const [email, setEmail] = useState(subadmin.email)
  const [phone, setPhone] = useState(subadmin.phone)
  const [password, setPassword] = useState()
  const [terminals, setTerminals] = useState(availableTerminals.map((t) => ({ ...t, checked: subadmin.terminals.includes(t._id) })))

  const onCheckTerminal = (_id, checked) => {
    const idx = terminals.findIndex((t) => t._id === _id)
    setTerminals([...terminals.slice(0, idx), { ...terminals[idx], checked }, ...terminals.slice(idx + 1)])
  }

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
      <button onClick={closeModal}>Stäng</button>
      <hr />

      <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
        <label style={{ paddingRight: 21 }}>Förnamn & Efternamn:</label>
        <input defaultValue={subadmin.name} onChange={(e) => setName(e.target.value)} className="change-input form-control" type="text" />
      </div>
      <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
        <label style={{ paddingRight: 21 }}>Email:</label>
        <input defaultValue={subadmin.email} onChange={(e) => setEmail(e.target.value.trim())} className="change-input form-control" type="text" />
      </div>
      <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
        <label style={{ paddingRight: 21 }}>Tel:</label>
        <input defaultValue={subadmin.phone} onChange={(e) => setPhone(e.target.value)} className="change-input form-control" type="text" />
      </div>
      <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
        <label style={{ paddingRight: 21 }}>Lösenord:</label>
        <input onChange={(e) => setPassword(e.target.value)} className="change-input form-control" type="text" />
      </div>
      <div>
        <p>Tillgång till åkerier:</p>
        {terminals.map((terminal) => (
          <div key={terminal._id}>
            <input defaultChecked={terminal.checked} onChange={(e) => onCheckTerminal(terminal._id, e.target.checked)} type="checkbox" />
            <label style={{ paddingRight: 7 }}>{terminal.company}</label>
            <br />
          </div>
        ))}
      </div>

      <Button
        className="save-settings-btn"
        style={{ width: '100%' }}
        type="submit"
        onClick={() => updateSubadmin({ ...subadmin, name, email, phone, password: password && password, terminals: terminals.reduce((acc, t) => (t.checked ? acc.concat(t._id) : acc), []) }).then(closeModal)}
      >
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara
      </Button>

      <Button className="smallQbuttonWarning" style={{ width: '100%' }} type="submit" onClick={() => deleteSubadmin(subadmin).then((r) => r && closeModal)}>
        <Glyphicon glyph="glyphicon glyphicon-remove" /> &nbsp; Ta bort lokaladmin
      </Button>
    </Modal>
  )
}

export default HandleSubadminModal
